import React, { useEffect, useMemo, useState } from "react";
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AddIcon from '@mui/icons-material/Add';

import { Grid, Tooltip, SnackbarContent, LinearProgress, Button, ButtonGroup, TextField, Switch, FormControlLabel } from "@mui/material";
import PndRestApi from "src/utils/pnd/PndRestApi";
import HubDutyConfigDetails from "./components/HubDutyConfigDetails";
import HubShiftDutyAddOrUpdate from "./components/HubShiftAddOrUpdate";
import { Card, CardBody, Modal, ModalBody } from "reactstrap";
import { showNotification, successNofication } from "src/shared/components/Notification";
//import { Redirect } from 'react-router-dom';
import { ERROR_MESSAGES } from "src/utils/pnd/PndConstants";
const ShiftDutyConfi = () => {
  useEffect(() => {
    getAllShiftTypes();
    getAllHubShiftConfigDetails();
  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isShiftType, setShiftType] = useState(null);
  const [isShiftId, setShiftId] = useState(null);
  const [isShiftName, setShiftName] = useState(null);
  const [isOpen, setOpenClearFilePopUp] = useState(false);
  // const [showConfirmation, setShowConfirmation] = useState(false);
  // const [isDayWorkingHr, setDayWorkingHr] = useState(null);
  const [totalWorkingHours, setTotalWorkingHours] = useState(0); // State for total working hours
  const [totalBreakTime, setTotalBreakTime] = useState(0); // State for total break time
  const [isRedirect, setIsRedirect] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [isShiftTypeNotFound, setShiftTypeNotFound] = useState(false);

  const [isAddShiftTypeOpen, setIsAddShiftTypeOpen] = useState(false);
  const [newShiftTypeName, setNewShiftTypeName] = useState("");
  const [editShiftTypeId, setEditShiftTypeId] = useState(null);
  const [newShiftTypeStatus, setNewShiftTypeStatus] = useState(true);

  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 15,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      {
        Header: 'Hub Name',
        accessor: 'hubInfo.hubName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Shift Name',
        accessor: 'shiftTypesInfo.shiftName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Shift Start Time',
        accessor: 'shiftStartTime',
        disableGlobalFilter: false,
        Cell: row => {
          const startTime = convertToHoursAndMinutes(row.value);
          return <span>{startTime}</span>;
        }

      },
      {
        Header: 'Shift End Time',
        accessor: 'shiftEndTime',
        disableGlobalFilter: false,
        Cell: row => {
          const startTime = convertToHoursAndMinutes(row.value);
          return <span>{startTime}</span>;
        }
      },
      {
        Header: 'Description',
        accessor: 'description',
        disableGlobalFilter: false,
      },
      {
        Header: 'Break Duration',
        accessor: 'breakDuration',
        disableGlobalFilter: false,
        Cell: row => {
          const startTime = convertToHours(row.value);
          return <span>{startTime}</span>;
        }
      },

      {
        Header: 'Action',
        accessor: 'edit',
        disableSortBy: true,
        Cell: row => (
          <div className="icon-style" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
            <Tooltip title="Click here to Edit details">
              <EditIcon style={{ cursor: "pointer" }} onClick={() => handleClick(row.row.original)} />
            </Tooltip>
          </div>
        ),
      },
    ],
    [],
  );
  if (isRedirect) {
    window.location.reload();
  }

  const handleOpenAddShiftType = (item = null) => {
    if (item) {
      setEditShiftTypeId(item.shiftTypeId);
      setNewShiftTypeName(item.shiftName);
      setNewShiftTypeStatus(item.status !== undefined ? item.status : true);
    } else {
      setEditShiftTypeId(null);
      setNewShiftTypeName("");
      setNewShiftTypeStatus(true);
    }
    setIsAddShiftTypeOpen(true);
  };

  const handleSaveShiftType = async () => {
    if (!newShiftTypeName.trim()) return;
    try {
      setLoading(true);
      const data = {
        shiftTypeId: editShiftTypeId,
        shiftName: newShiftTypeName,
        status: newShiftTypeStatus
      };
      const response = await PndRestApi.AddOrUpdateShiftType(data);
      if (response.status === 200 && response.data.status === 200) {
        successNofication("theme-light", "ltr", "Success", "Shift Type Saved Successfully");
        setIsAddShiftTypeOpen(false);
        getAllShiftTypes();
      } else {
        showNotification("theme-light", "ltr", `Error ${response.data.status}`, response.data.message);
      }
    } catch (error) {
      showNotification("theme-light", "ltr", "500", ERROR_MESSAGES.tryCatchError);
    } finally {
      setLoading(false);
    }
  };
  const getAllShiftTypes = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetAllShiftType();
      if (response.status === 200 && response.data.status === 200) {
        setShiftType(response.data.data);
      } else if (response.status === 200 && response.data.status === 204) {
        setShiftTypeNotFound(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data?.message}`,
        );
        return;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  const getAllHubShiftConfigDetails = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetAllHubDutyShiftConfig();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
      } else if (response.status === 200 && response.data.status === 204) {
        setNoRecordFound(true);

      } else {
        console.error('Unexpected response status:', response.status);

      }
    } catch (error) {
      console.error('Error fetching data:', error);

    } finally {
      setLoading(false);
    }
  };

  function convertToHours(timeInMilliseconds) {
    // Convert milliseconds to minutes
    const timeInMinutes = Math.floor(timeInMilliseconds / 60000);

    // Calculate hours and minutes
    const hours = Math.floor(timeInMinutes / 60);
    const minutes = timeInMinutes % 60;

    // Combine hours and minutes into a string
    return `${hours}h ${minutes}min`;
  }

  function convertToHoursAndMinutes(timeInMilliseconds) {
    // Convert milliseconds to minutes
    const timeInMinutes = Math.floor(timeInMilliseconds / 60000);

    // Calculate hours and minutes
    const hours = Math.floor(timeInMinutes / 60);
    const minutes = timeInMinutes % 60;

    let period = 'AM';
    let formattedHours = hours;

    // Convert hours to 12-hour format and determine AM or PM
    if (hours >= 12) {
      period = 'PM';
      formattedHours = hours === 12 ? 12 : hours - 12;
    } else if (hours === 0) {
      formattedHours = 12; // 12 AM
    }

    // Ensure minutes are formatted with leading zero if needed
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    // Combine hours, minutes, and period into a string
    return `${formattedHours}:${formattedMinutes} ${period}`;
  }



  function calculateTime(hours, minutes) {
    let hoursInMilliseconds = 0;
    let minutesInMilliseconds = 0;

    if (hours && hours?.value != 0) {
      hoursInMilliseconds = parseInt(hours) * 60 * 60 * 1000; // 1 hour = 3600 seconds = 3600 * 1000 milliseconds
    }

    if (minutes && minutes?.value != 0) {
      minutesInMilliseconds = parseInt(minutes) * 60 * 1000; // 1 minute = 60 seconds = 60 * 1000 milliseconds
    }

    return hoursInMilliseconds + minutesInMilliseconds;
  }

  const handleSubmit1 = async (formValues) => {
    try {

      formValues["hubInfo"] = {
        "hubId": formValues["hubInfo"]["value"]
      };
      if (formValues["hubInfo"] == null) {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: 500`,
          `Message: Please select Hub first`,
        )

        return;
      }
      if (temp) {
        formValues["shiftTypesInfo"] = {
          "shiftTypeId": formValues["shiftTypeId"]
        };
      } else {
        formValues["shiftTypesInfo"] = {
          "shiftTypeId": isShiftId
        };
      }
      formValues["shiftStartTime"] = calculateTime(formValues.shiftStartTimeHH?.value, formValues.shiftStartTimeMM?.value);
      formValues["shiftEndTime"] = calculateTime(formValues.shiftEndTimeHH?.value, formValues.shiftEndTimeMM?.value);
      formValues["breakDuration"] = calculateTime(formValues.breakDurationHH?.value, formValues.breakDurationMM?.value);

      if (formValues["shiftStartTime"] == formValues["shiftEndTime"]) {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode:500`,
          `Message:System will not accept same shift time.`,
        );
        return;

      }

      const totalWorkingMinutes = formValues["shiftEndTime"] - formValues["shiftStartTime"];
      const totalWorkingHours = Math.floor(totalWorkingMinutes / 60);
      const totalBreakTime = Math.floor(formValues["breakDuration"] / 60);
      setTotalWorkingHours(totalWorkingHours); // Update total working hours
      setTotalBreakTime(totalBreakTime); // Update total break time

      const response = await PndRestApi.AddOrUpdateHubDutyShiftConfig(formValues);
      if (response.status === 200 && response.data.status === 200) {
        successNofication(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          ERROR_MESSAGES.successMessage,
        );
        setIsRedirect(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message: ${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    }
  };

  const handleClick = (item) => {
    if (item) {
      //To handle to add new configuration
      if (item?.shiftTypeId) {
        setOpenClearFilePopUp(true);
        setShiftId(item?.shiftTypeId);
        setShiftName(item.shiftName);
      }
      //To handle to update new configuration
      if (item.shiftId) {
        setTempData(item);
        setViewDetailPopup(true);
        setTitle("Edit - Duty Shift Details")

      }
    }
  };

  const toggle = () => {
    setOpenClearFilePopUp(prevState => !prevState)
  }
  const toggleEdit = () => {
    setViewDetailPopup(prevState => !prevState)
  }
  return (
    <div className="p-2">
      <Card className="border-0 shadow-sm mb-4">
        <CardBody className="p-0">
          <div className="p-3" style={{ background: '#fff', borderRadius: '8px' }}>
            <div className="d-flex flex-wrap align-items-center justify-content-between mb-3">
              <div className="d-flex align-items-center mb-2 mb-md-0">
                <div
                  className="d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: '45px',
                    height: '45px',
                    background: 'rgba(102, 126, 234, 0.1)',
                    borderRadius: '12px',
                    color: '#667eea'
                  }}
                >
                  <ScheduleIcon style={{ fontSize: '24px' }} />
                </div>
                <div>
                  <h5 className="m-0 fw-bold text-dark" style={{ fontSize: '1.25rem', letterSpacing: '0.2px' }}>Hub Shift Details</h5>
                  <p className="m-0 text-muted" style={{ fontSize: '0.85rem', marginTop: '4px', lineHeight: '1.5' }}>
                    Configure and manage your duty shift timings.<br/>
                    <span style={{ color: '#1a8a50', fontWeight: 500 }}>Tip: </span> 
                    To create a new schedule, simply <strong>Add a Shift Type</strong>, select it below, enter the start and end times, and save the information!
                  </p>
                </div>
              </div>

              <div>
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  startIcon={<AddIcon style={{ fontSize: '16px' }} />}
                  onClick={() => handleOpenAddShiftType()}
                  style={{
                      borderRadius: '6px',
                      textTransform: 'none',
                      fontWeight: 600,
                      padding: '4px 12px',
                      fontSize: '0.75rem'
                  }}
                >
                  Add Shift Type
                </Button>
              </div>
            </div>

            <div className="d-flex flex-wrap gap-2">
              {isShiftType && isShiftType.map(item => (
                <ButtonGroup size="small" key={item.shiftTypeId} variant="contained" aria-label="outlined primary button group" style={{ boxShadow: '0 2px 6px rgba(33, 179, 104, 0.2)', borderRadius: '6px' }}>
                  <Button
                    onClick={() => handleClick(item)}
                    startIcon={<ScheduleIcon style={{ fontSize: '16px' }} />}
                    className="shift-button"
                    style={{
                      background: 'linear-gradient(135deg, #21b368 0%, #1a8a50 100%)',
                      textTransform: 'none',
                      fontWeight: 600,
                      padding: '4px 12px',
                      fontSize: '0.75rem',
                      borderTopLeftRadius: '6px',
                      borderBottomLeftRadius: '6px',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                    }}
                  >
                    {item.shiftName}
                  </Button>
                  <Button
                    onClick={() => handleOpenAddShiftType(item)}
                    style={{
                      background: 'linear-gradient(135deg, #1f9d5c 0%, #177a45 100%)',
                      borderLeft: '1px solid rgba(255,255,255,0.2)',
                      borderTopRightRadius: '6px',
                      borderBottomRightRadius: '6px',
                      padding: '0 8px',
                      minWidth: '32px'
                    }}
                  >
                    <EditIcon style={{ fontSize: '14px', color: 'white' }} />
                  </Button>
                </ButtonGroup>
              ))}
            </div>
          </div>
        </CardBody>
      </Card>

      <Card className="border-0 shadow-sm mb-2">
        <CardBody className="p-2">
          {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && <HubDutyConfigDetails reactTableData={reactTableData} />}
          {isShiftTypeNotFound && <SnackbarContent message={'Shift Type Not Found. Please contact Informap Support'} />}
          {isNoRecordFound && <SnackbarContent message={'Duty Shift Configuration Not Found. Please select Shift Type and configure the shift'} />}
          {loading && <LinearProgress color="primary" />}
        </CardBody>
      </Card>

      {/* Modals */}
      {isOpen && (
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          modalClassName="ltr-support"
          className="theme-light ltr-support"
          size="lg"
          style={{ maxWidth: '900px' }}
        >
          <div
            className="position-relative"
            style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              padding: '1.5rem 2rem',
              borderRadius: '0.5rem 0.5rem 0 0',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}
          >
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div
                  className="d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: '48px',
                    height: '48px',
                    background: 'rgba(255,255,255,0.2)',
                    borderRadius: '12px',
                    backdropFilter: 'blur(10px)'
                  }}
                >
                  <ScheduleIcon style={{ fontSize: '28px', color: '#fff' }} />
                </div>
                <div>
                  <h4
                    className="m-0 text-white fw-bold"
                    style={{
                      fontSize: '1.5rem',
                      letterSpacing: '0.5px',
                      textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                  >
                    Configure Shift - {isShiftName}
                  </h4>
                  <p className="m-0 text-white-50 small">
                    Set up shift timing and break duration
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={toggle}
                className="btn-close-custom"
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                  e.currentTarget.style.transform = 'rotate(90deg)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                  e.currentTarget.style.transform = 'rotate(0deg)';
                }}
              >
                <CloseIcon style={{ color: '#fff', fontSize: '20px' }} />
              </button>
            </div>
          </div>
          <ModalBody className="p-0" style={{ background: '#f8f9fa' }}>
            <div style={{ maxHeight: 'calc(90vh - 120px)', overflowY: 'auto' }}>
              <HubShiftDutyAddOrUpdate onSubmit={handleSubmit1} isShiftName={isShiftName} isShiftId={isShiftId} toggle={toggle} />
            </div>
          </ModalBody>
        </Modal>
      )}

      {viewDetailPopup && (
        <Modal
          isOpen={viewDetailPopup}
          toggle={toggleEdit}
          modalClassName="ltr-support"
          className="theme-light ltr-support"
          size="lg"
          style={{ maxWidth: '900px' }}
        >
          <div
            className="position-relative"
            style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              padding: '1.5rem 2rem',
              borderRadius: '0.5rem 0.5rem 0 0',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}
          >
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div
                  className="d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: '48px',
                    height: '48px',
                    background: 'rgba(255,255,255,0.2)',
                    borderRadius: '12px',
                    backdropFilter: 'blur(10px)'
                  }}
                >
                  <EditIcon style={{ fontSize: '28px', color: '#fff' }} />
                </div>
                <div>
                  <h4
                    className="m-0 text-white fw-bold"
                    style={{
                      fontSize: '1.5rem',
                      letterSpacing: '0.5px',
                      textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                  >
                    {isTitle}
                  </h4>
                  <p className="m-0 text-white-50 small">
                    Update shift configuration details
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={toggleEdit}
                className="btn-close-custom"
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  borderRadius: '50%',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                  e.currentTarget.style.transform = 'rotate(90deg)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                  e.currentTarget.style.transform = 'rotate(0deg)';
                }}
              >
                <CloseIcon style={{ color: '#fff', fontSize: '20px' }} />
              </button>
            </div>
          </div>
          <ModalBody className="p-0" style={{ background: '#f8f9fa' }}>
            <div style={{ maxHeight: 'calc(90vh - 120px)', overflowY: 'auto' }}>
              {temp && <HubShiftDutyAddOrUpdate onSubmit={handleSubmit1} isShiftName={isShiftName} isShiftId={isShiftId} dataInfo={temp} />}
              {(totalWorkingHours > 0 || totalBreakTime > 0) && (
                <div className="p-3 bg-white border-top">
                  <div className="d-flex justify-content-around">
                    <div className="text-center">
                      <small className="text-muted d-block">Total Working Hours</small>
                      <strong className="text-primary" style={{ fontSize: '1.2rem' }}>{totalWorkingHours}h</strong>
                    </div>
                    <div className="text-center">
                      <small className="text-muted d-block">Total Break Time</small>
                      <strong className="text-warning" style={{ fontSize: '1.2rem' }}>{totalBreakTime}min</strong>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>
      )}

      {isAddShiftTypeOpen && (
        <Modal isOpen={isAddShiftTypeOpen} toggle={() => setIsAddShiftTypeOpen(false)} className="theme-light" centered style={{ maxWidth: '400px' }}>
          <div className="modal-header" style={{ borderBottom: 'none', paddingBottom: '0' }}>
            <h5 className="modal-title fw-bold" style={{ fontSize: '1.1rem', color: '#333' }}>
              {editShiftTypeId ? 'Update Shift Type' : 'Add New Shift Type'}
            </h5>
            <button type="button" className="btn-close" onClick={() => setIsAddShiftTypeOpen(false)} style={{ fontSize: '12px' }}></button>
          </div>
          <ModalBody style={{ padding: '1.5rem' }}>
            <div className="mb-4">
              <TextField
                label="Shift Name"
                variant="outlined"
                fullWidth
                size="small"
                value={newShiftTypeName}
                onChange={(e) => setNewShiftTypeName(e.target.value)}
                placeholder="e.g. Morning Shift"
                InputProps={{
                  style: { borderRadius: '8px' }
                }}
              />
            </div>
            {editShiftTypeId && (
              <div 
                className="mb-4 d-flex align-items-center justify-content-between px-3 py-2" 
                style={{ 
                  background: newShiftTypeStatus ? 'rgba(33, 179, 104, 0.08)' : 'rgba(220, 53, 69, 0.08)', 
                  border: `1px solid ${newShiftTypeStatus ? 'rgba(33, 179, 104, 0.3)' : 'rgba(220, 53, 69, 0.3)'}`,
                  borderRadius: '8px',
                  transition: 'all 0.3s ease'
                }}
              >
                <span style={{ 
                  fontWeight: 600, 
                  fontSize: '0.85rem', 
                  color: newShiftTypeStatus ? '#1a8a50' : '#dc3545' 
                }}>
                  {newShiftTypeStatus ? "Active Status" : "Inactive Status"}
                </span>
                <FormControlLabel
                  control={
                    <Switch
                      checked={newShiftTypeStatus}
                      onChange={(e) => setNewShiftTypeStatus(e.target.checked)}
                      color={newShiftTypeStatus ? "success" : "error"}
                      size="small"
                    />
                  }
                  label=""
                  style={{ margin: 0 }}
                />
              </div>
            )}
            <div className="d-flex justify-content-end gap-2 mt-2">
              <Button 
                variant="outlined" 
                color="inherit" 
                onClick={() => setIsAddShiftTypeOpen(false)}
                style={{ borderRadius: '6px', textTransform: 'none', fontWeight: 600, color: '#666', borderColor: '#ddd' }}
              >
                Cancel
              </Button>
              <Button 
                variant="contained" 
                onClick={handleSaveShiftType} 
                disabled={!newShiftTypeName.trim() || loading}
                style={{ 
                  borderRadius: '6px', 
                  textTransform: 'none', 
                  fontWeight: 600,
                  background: (!newShiftTypeName.trim() || loading) ? '#e0e0e0' : 'linear-gradient(135deg, #21b368 0%, #1a8a50 100%)',
                  color: (!newShiftTypeName.trim() || loading) ? '#9e9e9e' : '#fff',
                  boxShadow: (!newShiftTypeName.trim() || loading) ? 'none' : '0 4px 12px rgba(33, 179, 104, 0.25)'
                }}
              >
                {loading ? 'Saving...' : 'Save Changes'}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      )}
    </div>
  );
};

export default ShiftDutyConfi;
